import {
  createUnifiedTheme,
  genPageTheme,
  pageTheme as defaultPageThemes,
  palettes,
  shapes,
} from '@backstage/theme';

// Iron Phoenix brand colors
const colors = {
  darkBlue: '#14477d',
  midBlue: '#1b75bc',
  lightBlue: '#6dcff6',
  purple: '#8a0d71',
  orange: '#f7931e',
};

// Single blue gradient for all page headers (no green/pink per-route)
const bluePageTheme = genPageTheme({
  colors: [colors.darkBlue, colors.midBlue, colors.lightBlue],
  shape: shapes.wave,
  options: { fontColor: '#FFFFFF' },
});

const ironPhoenixPageThemes: Record<string, typeof bluePageTheme> = {};
for (const key of Object.keys(defaultPageThemes)) {
  ironPhoenixPageThemes[key] = bluePageTheme;
}

const baseOptions = {
  palette: {
    ...palettes.light,
    primary: {
      main: colors.midBlue,
      light: colors.lightBlue,
      dark: colors.darkBlue,
    },
    secondary: {
      main: colors.purple,
      light: colors.orange,
      dark: colors.purple,
    },
    navigation: {
      ...palettes.light.navigation,
      background: colors.darkBlue,
      color: '#FFFFFF',
      indicator: colors.lightBlue,
      selectedColor: colors.lightBlue,
      navItem: {
        hoverBackground: 'rgba(109, 207, 246, 0.15)',
      },
      // My Groups / secondary sidebar panel – blue to match main nav
      submenu: {
        background: '#1a4d82',
      },
    },
    link: colors.midBlue,
    linkHover: colors.darkBlue,
  },
  pageTheme: ironPhoenixPageThemes,
};

// Light theme (white/dark blue nav)
export const ironPhoenixTheme = createUnifiedTheme({
  ...baseOptions,
});

// Dark theme (dark screen, Iron Phoenix blues for accents)
const darkPalette = {
  ...palettes.dark,
  primary: {
    main: colors.lightBlue,
    dark: colors.midBlue,
  },
  secondary: {
    main: colors.orange,
    light: colors.lightBlue,
    dark: colors.purple,
  },
  // Left sidebar: keep same blue as light theme (unchanged)
  navigation: {
    ...palettes.light.navigation,
    background: colors.darkBlue,
    color: '#FFFFFF',
    indicator: colors.lightBlue,
    selectedColor: colors.lightBlue,
    navItem: {
      hoverBackground: 'rgba(109, 207, 246, 0.15)',
    },
    submenu: {
      background: '#1a4d82',
    },
  },
  link: colors.lightBlue,
  linkHover: colors.midBlue,
};

export const ironPhoenixDarkTheme = createUnifiedTheme({
  palette: darkPalette,
  pageTheme: ironPhoenixPageThemes,
});
